import '../App.css'
import { Link } from 'react-router-dom';

function Bottone ({nome}:{nome:string}){
    return(
        <button className='Button'>
        <Link to={`/funny/${nome}`}> {nome} </Link>
        </button>
    )
}

export default Bottone;

